
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.removeItem("token");
    navigate("/login");
  }, [navigate]);
  return (
    <div className="container">
      <h1>You have been logged out.</h1>
    </div>
  );
};

export default Logout;
